import { useEffect } from 'react';

export const useTrackBreadcrumb = (trackName: string) => {
  useEffect(() => {
    const event = new CustomEvent('trackNameChanged', { 
      detail: { trackName } 
    });
    window.dispatchEvent(event);
  }, [trackName]);
};
